export default {
  name: "SecurityDemographicsCompetition",
  props: {
    crimeStats: {
      type: Object,
      default: () => ({
        precinct: "Local Precinct",
        crimeIndex: "Unknown",
        periodIncrease: "No data available",
        incidentSummary: [],
        lastUpdated: "N/A",
        stationContact: "N/A"
      })
    },
    incidents: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // Generate dynamic incidents from crime data
    dynamicIncidents() {
      // Use the incidents prop if provided, otherwise generate from crime data
      if (this.incidents && this.incidents.length > 0) {
        return this.incidents;
      }
      
      // Generate incidents from crime stats
      const incidents = [];
      const crimeData = this.crimeStats;
      
      // Convert crime categories to incident format
      if (crimeData.incidentSummary && crimeData.incidentSummary.length > 0) {
        crimeData.incidentSummary.forEach((crime, index) => {
          // Determine severity based on crime type
          let severity = "high";
          let title = "";
          
          if (crime.category === "Assault" || crime.count > 10) {
            severity = "critical";
          }
          
          // Create incident title based on crime data
          if (crime.trend && crime.trend.startsWith("+")) {
            title = `Alert: ${crime.category} Increasing (${crime.count} cases, ${crime.trend})`;
          } else if (crime.trend && crime.trend.startsWith("-")) {
            title = `Improving: ${crime.category} Decreasing (${crime.count} cases, ${crime.trend})`;
          } else {
            title = `Monitor: ${crime.category} (${crime.count} cases)`;
          }
          
          incidents.push({
            id: index + 1,
            title: title,
            timestamp: `${crimeData.lastUpdated || '2025-09-30'} ${Math.floor(Math.random() * 12) + 10}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
            status: "Analyzed",
            severity: severity,
            trend: crime.trend || "0%",
            count: crime.count
          });
        });
      }
      
      // If no crime data, show placeholder incidents
      if (incidents.length === 0) {
        return [
          {
            id: 1,
            title: "No Recent Crime Data Available",
            timestamp: "2025-11-28 17:30",
            status: "No Data",
            severity: "info",
          },
          {
            id: 2,
            title: "Awaiting Updated Crime Statistics",
            timestamp: "2025-11-27 10:45",
            status: "Pending",
            severity: "info",
          },
        ];
      }
      
      return incidents;
    }
  }
};